import kebabCase from 'lodash.kebabcase';

/**
 * Runtime implementations for the `String.prototype` methods that
 * `@netfront/common-library` only declares as ambient types (see its
 * `index.d.ts`), without ever shipping an implementation. Imported once,
 * for its side effects, in `pages/_app.tsx`.
 */

String.prototype.capitalize = function capitalize(this: string): string {
  return this.charAt(0).toUpperCase() + this.slice(1);
};

String.prototype.contains = function contains(this: string, value: string): boolean {
  return this.toLowerCase().includes(value.toLowerCase());
};

String.prototype.formatPossessive = function formatPossessive(this: string): string {
  return this.endsWith('s') || this.endsWith('S') ? `${this}'` : `${this}'s`;
};

String.prototype.toKebabCase = function toKebabCase(this: string): string {
  return kebabCase(this);
};
